module.exports = __webpack_public_path__ + "media/assets/partners/backer_founder-fe8d2037d6d28ffe5bff27fdbf2bf474.svg";